import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { FHA_KEY, FhaSegment } from '../types/Fha';
import { FhaLayer, FhaSubLayer } from '../types/Layer';
import { getCurrentSeason } from './seasonSelectors';
import { activeSubLayerData } from './fhaSelectors';

type ActiveSubLayer = {
  date: string;
  layer: FhaSegment;
  segmentSelected: FhaSegment;
};

const getFhaSubLayers = (
  state: AppState,
  props: { index: number }
): FhaSubLayer[] => {
  const season = getCurrentSeason(state, props);
  const fha = state.layers.list[season]?.[FHA_KEY] as FhaLayer | undefined;
  return fha?.subLayers ?? [];
};

export const getFhaTimelapseFrames = createSelector(
  [getFhaSubLayers, activeSubLayerData],
  (subLayers, activeData: ActiveSubLayer | undefined) => {
    const segment = activeData?.segmentSelected ?? activeData?.layer;
    const eventDates = subLayers.map((e) => e.date);
    const imageUris = segment
      ? subLayers
          .map((e) => e[segment as FhaSegment]?.imageUri)
          .filter((uri): uri is string => Boolean(uri))
      : [];
    const activeImageUri =
      segment && activeData
        ? subLayers.find((e) => e.date === activeData.date)?.[segment as FhaSegment]
            ?.imageUri
        : undefined;
    return { eventDates, imageUris, activeImageUri };
  }
);

export const getFhaTimelapsePlaying = (state: AppState): boolean =>
  !!state.layers.isFhaTimelapsePlaying;
